/**
 *
 * Circle Statistic
 *
 * UI that handles the functionality for animating the circle statistic shortcode
 */

const $ = require( 'jquery' );

var CircleStat = function(el){

  //setup some variables
  this.$el   = $(el);
  this.$wayPoint = null;
  this.$scrollParent = this.getScrollParent(el);

  this.init();

};

CircleStat.prototype.init = function(){
  const animationAttr = this.$el.attr("data-animation");
  if (animationAttr && animationAttr === 'false') {
    return;
  }

  this.$wayPoint = new Waypoint({
    element : this.$el[0],
    handler: function(direction) {

      const $el     = $(this.element);
      let $circle   = $el.find( 'circle.a.b' );
      let $text    = $el.find( 'text.c' );
      let counter   = $el.find('text.c')[0];
      let countTo   = $el.find('text.d')[0].textContent;
      let type    = $el.find('text.f')[0].textContent;
      let duration  = ($el.find( 'text.e' )[0].textContent);
      let dashArray  = parseInt( $circle.attr('stroke-dashoffset') );
      let percent    = dashArray - ( dashArray*countTo/100 );

      //dashArray-(dashArray*percent/100)
      $circle.addClass('animate');

      TweenMax
        .to(
          $circle,
          duration,
          {strokeDashoffset: type==='perc'?percent:0}
        );

      if( !$text.hasClass( 'animated' ) && type === 'perc' ){

        $text.addClass('animated');

        $({ countNum: 0}).animate({
            countNum: countTo
          },
          {
            duration: duration*1000, // this should be dynamic -> same time that is passed to shortcode
            easing:'linear',
            step: function() {
              counter.textContent = Math.floor(this.countNum)+'%';
            },
            complete: function() {
              counter.textContent = this.countNum+'%';
            }
          });

      }
      else if(type === 'times') {
        counter.textContent = countTo+'X';
      }

      this.destroy();

    },
    offset: '80%',
    context: this.getWaypointContext(),
  });
};

CircleStat.prototype.getScrollParent = function(element, includeHidden) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === "absolute";
  var overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/;

  if (style.position === "fixed") return document.body;
  for (var parent = element; (parent = parent.parentElement);) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === "static") {
      continue;
    }
    if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX)) return parent;
  }

  return window;
};

CircleStat.prototype.getWaypointContext = function() {
  var $scrollContainer = this.$el.closest('.js-scroll-container');
  return $scrollContainer.css('overflow-y') === 'scroll' ? $scrollContainer[0] : undefined;
};

$(document)
  //add custom event to reinit all functions after AJAX has been loaded
  .on( 'ajaxInit', function(){
    $('.itbl-svg__stat-circle').each(function(){
      new CircleStat(this);

      // Check if it's in viewport to start the animation?
    });
  } )
  .ready(function(){
  $('.itbl-svg__stat-circle').each(function(){
    new CircleStat(this);

    // Check if it's in viewport to start the animation?
  });
});
